import M201WorkableScheduleRepository from "./M201WorkableScheduleRepository"
import C201LoginRepository from "./c201LoginRepository"
import C201MasterLoginRepository from "./c201MasterLoginRepository"
import C204SubdomainCheckRepository from "./c204SubdomainCheckRepository"
import C205HeaderInfoRepository from "./c205HeaderInfoRepository"
import c206ContractInfoRepository from "./c206ContractInfoRepository"
import c207CheckSalesChannelRepository from "./c207CheckSalesChannelRepository"
import T201TmpOrderRepository from "./t201TmpOrderRepository"
import F201FirstOrderRepository from "./f201FirstOrderRepository"
import S201TopPageRepository from "./s201TopPageRepository"
import S202NeoContractDetailsTblRepository from "./S202NeoContractDetailsTblRepository"
import S202NeoContractChangesRepository from "./S202NeoContractChangesRepository"
import S203NeoContractOrderRepository from "./S203NeoContractOrderRepository"
import S204ChatContractDetailsRepository from "./s204ChatContractDetailsRepository"
import S204ChatContractChangesRepository from "./s204ChatContractChangesRepository"
import S205ChatContractOrderRepository from "./s205ChatContractOrderRepository"
import S206NumberChangeRepository from "./s206NumberChangeRepository"
import S207CustomerDetailsRepository from "./s207CustomerDetailsRepository"
import S207CustomerChangesRepository from "./s207CustomerChangesRepository"
import S207MailChangesRepository from "./s207MailChangesRepository"
import S207PayMethodChangesRepository from "./s207PayMethodChangesRepository"
import S207PasswordChangesRepository from "./s207PasswordChangesRepository"
import S208PasswordResetRepository from "./s208PasswordResetRepository"
import S209CreateAccountRepository from "./s209CreateAccountRepository"
import S210OrderHistoryRepository from "./s210OrderHistoryRepository"
import S212AccountManagementRepository from "./s212AccountManagementRepository";
import S213ContractChangesRepository from "./s213ContractChangesRepository";
import S213ContractDetailsRepository from "./s213ContractDetailsRepository"
import S214QuotationRepository from "./s214QuotationRepository";
import ZipCloudRepository from "./zipCloudRepository"
import I202OrderListsRepository from "./I202OrderListsRepository"
import CreateSqlRepository from "./zz_dev_createSqlRepository"
import LbcCodeRepository from "./lbcCodeRepository";

const repositories = {
    M201WorkableSchedule: M201WorkableScheduleRepository,
    c201Login: C201LoginRepository,
    c201MasterLogin: C201MasterLoginRepository,
    c204SubdomainCheck: C204SubdomainCheckRepository,
    c205HeaderInfo: C205HeaderInfoRepository,
    c206ContractInfo: c206ContractInfoRepository,
    c207CheckSalesChannel:c207CheckSalesChannelRepository,
    t201TmpOrder: T201TmpOrderRepository,
    f201FirstOrder: F201FirstOrderRepository,
    topPage: S201TopPageRepository,
    s202NeoContractDetailsTbl: S202NeoContractDetailsTblRepository,
    s202NeoContractChanges: S202NeoContractChangesRepository,
    s203NeoContractOrder: S203NeoContractOrderRepository,
    s204ChatContractDetails: S204ChatContractDetailsRepository,
    s204ChatContractChanges: S204ChatContractChangesRepository,
    s205ChatContractOrder: S205ChatContractOrderRepository,
    s206NumberChange: S206NumberChangeRepository,
    s207CustomerDetails: S207CustomerDetailsRepository,
    s207CustomerChanges : S207CustomerChangesRepository,
    s207MailChanges: S207MailChangesRepository,
    s207PayMethodChanges: S207PayMethodChangesRepository,
    s207PasswordChanges: S207PasswordChangesRepository,
    s208PasswordReset: S208PasswordResetRepository,
    s209CreateAccount: S209CreateAccountRepository,
    s210OrderHistory: S210OrderHistoryRepository,
    s212AccountManagement: S212AccountManagementRepository,
    s213ContractChanges: S213ContractChangesRepository,
    s213ContractDetails: S213ContractDetailsRepository,
    s214Quotation: S214QuotationRepository,
    zipCloud: ZipCloudRepository,
    i202OrderLists: I202OrderListsRepository,
    createSqlRepository: CreateSqlRepository,
    lbcCode: LbcCodeRepository
}

export default {
    get (name) {
        return repositories[name]
    }
}
